export const GET_DISPUTES = "GET_DISPUTES";
export const GET_DISPUTES_SUCCESS = "GET_DISPUTES_SUCCESS";
export const GET_DISPUTES_FAIL = "GET_DISPUTES_FAIL";

export const GET_DISPUTE_VIEW = "GET_DISPUTE_VIEW";
export const GET_DISPUTE_VIEW_SUCCESS = "GET_DISPUTE_VIEW_SUCCESS";
export const GET_DISPUTE_VIEW_FAIL = "GET_DISPUTE_VIEW_FAIL";
